import consts from './consts';

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

class UserStorage {
  static sessionKey = '';

  static getUserAPIKey() {
    if (!localStorage) {
      return null;
    }
    let store = localStorage.getItem(consts.store);
    store = store ? JSON.parse(store) : {};
    const user = store.userState;
    if (!user || !user.key) {
      return null;
    }
    const username = user.impersonator ? user.impersonator : user.username;
    return user && user.key ? `${username}:${user.key}` : null;
  }
  static getSessionId() {
    if (UserStorage.sessionKey) {
      return UserStorage.sessionKey;
    }
    if (localStorage) {
      const key = localStorage.getItem('session_key');
      UserStorage.sessionKey = key || '';
      return key;
    }
    return '';
  }
  static setSessionId(session_key) {
    const key = session_key || uuidv4();
    UserStorage.sessionKey = key;
    if (localStorage) {
      localStorage.setItem('session_key', key);
    }
  }
  static getImpersonatedUserID() {
    if (!localStorage) {
      return null;
    }
    let store = localStorage.getItem(consts.store);
    store = store ? JSON.parse(store) : {};
    const user = store.userState;
    return user && user.impersonatedUser ? user.impersonatedUser.email : null;
  }
}

export default UserStorage;
